import api from "../../../utilidades/interceptor";

const apiUrl = process.env.REACT_APP_API_KEY;

export const getExcesosVelocidad = async (params) => {
    try {
        const response = await api.get(`${apiUrl}/incidentes/excesos-velocidad`, { params });
        return response.data;
    }
    catch (error) {
        console.error("Error fetching Excesos de Velocidad:", error);
        throw error;
    }
};